export default __webpack_public_path__ + "static/media/OTPEmail.6bc9d250.png";